import { LocalDate } from './local-date.model';
import { StatusAcceptanceType } from '../constants';
import { LatestNotification } from '../state/monitoring/models';

export interface Tracking {
  acceptanceType: StatusAcceptanceType;
  assignedArrivalTime: number | LocalDate;
  current: boolean;
  address: string;
  statusCode: string;
  statusDescription: string;
  latestNotification: LatestNotification;
  carrierMessage?: string;
  title?: string;
}
